import { useSession } from '@/features/auth/session';
import { visibleNav } from './nav';
import { SidebarGroups } from './shell';

export function SidebarNav({ onNavigate }: { onNavigate?: () => void }) {
  const { permissions } = useSession();
  return <SidebarGroups groups={visibleNav((p) => permissions.has(p))} onNavigate={onNavigate} />;
}
